import { render, staticRenderFns } from "./EditProtocol.vue?vue&type=template&id=6d198c64&scoped=true&"
import script from "./EditProtocol.vue?vue&type=script&lang=js&"
export * from "./EditProtocol.vue?vue&type=script&lang=js&"
import style0 from "./EditProtocol.vue?vue&type=style&index=0&id=6d198c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d198c64",
  null
  
)

export default component.exports